import { Component, input, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface DataDisplayItem {
  label: string;
  value?: string[];
  template?: TemplateRef<any>;
}

@Component({
  selector: 'htx-data-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './data-display.component.html',
  styleUrls: ['./data-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataDisplayComponent {
  /**
   * Header title for the card
   */
  title = input<string>('');

  /**
   * Optional icon to display in the header
   */
  icon = input<string>('');

  /**
   * Array of data items with label and value(s)
   */
  data = input<DataDisplayItem[]>([]);
}
